/*
  사업자 정보 — 법무 문서·푸터·결제 영수증·이메일 발신자 표기에 공통 사용.
  값 갱신 시 이 파일 한 곳만 고치면 모든 페이지에 반영된다.
*/
export const COMPANY = {
  /** 상호 (한글 / 영문) */
  name: '에이치소프트',
  nameEn: 'HSoft',

  /** 서비스 브랜드 — 별도 표기 */
  brand: 'TilOurDay',
  brandUrl: 'https://tilourday.com',

  /** 대표자 — 사용자 추가 정보가 들어오면 갱신 */
  representative: '배현우',

  /** 사업자등록번호 (한국) */
  businessNo: '895-37-01515',

  /** 통신판매업 신고번호 — 미신고 상태면 placeholder 유지 후 신고 후 갱신 */
  ecommerceNo: '신고예정',

  /** 사업장 주소 */
  addressKr: '경기도 안양시 동안구 관악대로 135',
  addressEn: '135 Gwanak-daero, Dongan-gu, Anyang-si, Gyeonggi-do, Republic of Korea',

  /** 고객 응대 채널 */
  email: 'b_h_woo@naver.com',
  phone: '',

  /** Paddle Merchant of Record */
  paddle: {
    merchantName: 'Paddle.com Market Limited',
    merchantAddress: 'Judd House, 18-29 Mora Street, London, EC1V 8BT, United Kingdom',
    merchantUrl: 'https://www.paddle.com/legal/checkout-buyer-terms',
  },

  /** 마지막 개정일 — 법무 문서 갱신 시 함께 변경 */
  policyEffectiveDate: '2026-05-07',
} as const;

export type CompanyInfo = typeof COMPANY;
